import * as Types from '../../generated-types';

import { GraphQLClient } from 'graphql-request';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
export type CreateNotificationTokenMutationVariables = Types.Exact<{
  token: Types.Scalars['String'];
  userId: Types.Scalars['ID'];
}>;


export type CreateNotificationTokenMutation = { __typename?: 'Mutation', createNotificationToken?: { __typename?: 'NotificationToken', documentId: string, token: string, user?: { __typename?: 'UsersPermissionsUser', documentId: string, username: string, firstName: string, lastName: string, color?: string | null, isPartTime?: boolean | null, notificationTokens: Array<{ __typename?: 'NotificationToken', documentId: string, token: string } | null> } | null } | null };

export type DeleteNotificationTokenMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type DeleteNotificationTokenMutation = { __typename?: 'Mutation', deleteNotificationToken?: { __typename?: 'DeleteMutationResponse', documentId: string } | null };


export const CreateNotificationTokenDocument = `
    mutation createNotificationToken($token: String!, $userId: ID!) {
  createNotificationToken(data: {token: $token, user: $userId}) {
    documentId
    token
    user {
      documentId
      username
      firstName
      lastName
      color
      isPartTime
      notificationTokens(pagination: {limit: -1}) {
        documentId
        token
      }
    }
  }
}
    `;
export const useCreateNotificationTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateNotificationTokenMutation, TError, CreateNotificationTokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateNotificationTokenMutation, TError, CreateNotificationTokenMutationVariables, TContext>(
      ['createNotificationToken'],
      (variables?: CreateNotificationTokenMutationVariables) => fetcher<CreateNotificationTokenMutation, CreateNotificationTokenMutationVariables>(client, CreateNotificationTokenDocument, variables, headers)(),
      options
    );
export const DeleteNotificationTokenDocument = `
    mutation deleteNotificationToken($id: ID!) {
  deleteNotificationToken(documentId: $id) {
    documentId
  }
}
    `;
export const useDeleteNotificationTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteNotificationTokenMutation, TError, DeleteNotificationTokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteNotificationTokenMutation, TError, DeleteNotificationTokenMutationVariables, TContext>(
      ['deleteNotificationToken'],
      (variables?: DeleteNotificationTokenMutationVariables) => fetcher<DeleteNotificationTokenMutation, DeleteNotificationTokenMutationVariables>(client, DeleteNotificationTokenDocument, variables, headers)(),
      options
    );